/* eslint-disable @typescript-eslint/no-misused-promises */
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { useProcedureInstanceStore } from "@/frontend/store/ProcedureInstanceStore";
import { I18n } from "@/i18n/I18n";
import { CUSTOM_FIELD_TYPES } from "@/types/customFieldTypes";
import { ParameterInputType, ParameterSubjectType, ParameterType } from "@/types/parameterTypes";
import { useState } from "react";
import { BasicButton } from "../buttons/BasicButton";
import { Button, Modal } from "react-bootstrap";
import { TitleAndIdentifierAndDescriptionFormInputs } from "./TitleAndIdentifierAndDescriptionFormInputs";

export function AddIntroductionAssetButton() {
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState<string>('');
  const [titleError, setTitleError] = useState<string | undefined>(undefined);
  const [identifier, setIdentifier] = useState<string>('');
  const [identifierError, setIdentifierError] = useState<string | undefined>(undefined);
  const [description, setDescription] = useState<string>('');
  const procedure = useProcedureInstanceStore(state => state.procedureInstance);
  const createParameter = useParameterStore(state => state.createParameter);

  const handleSave = async () => {
    if (!title) {
      setTitleError(I18n.get('titleRequired'));
      return;
    }
    if (identifierError || titleError || !procedure?.id) {
      return;
    }
    const request = {
      title,
      fieldType: CUSTOM_FIELD_TYPES.File,
      position: 0,
      subjectId: procedure.id,
      subjectType: ParameterSubjectType.PROCEDURE,
      type: ParameterType.INTRODUCTION,
      inputType: ParameterInputType.FREE_FORM,
      identifier,
      procedureId: procedure.id,
      description
    };
    await createParameter(request).then((response) => {
      handleClose();
      return response;
    });
  };

  const handleClose = () => {
    setShowModal(false);
    setTitle('');
    setIdentifier('');
    setDescription('');
    setTitleError(undefined);
    setIdentifierError(undefined);
  };

  return (
    <div>
      <BasicButton className='btn btn-sm btn-primary mt-2' onClick={() => setShowModal(true)} label={I18n.get('addIntroductionAsset')} />
      {showModal &&
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{I18n.get('addIntroductionAsset')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TitleAndIdentifierAndDescriptionFormInputs title={title} setTitle={setTitle} titleError={titleError} setTitleError={setTitleError} identifier={identifier} setIdentifier={setIdentifier} identifierError={identifierError} identifierOptional setIdentifierError={setIdentifierError} description={description} setDescription={setDescription} subjectId={procedure?.id || ''} subjectType={ParameterSubjectType.PROCEDURE} parameterType={ParameterType.INTRODUCTION} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>{I18n.get('cancel')}</Button>
            <Button type="submit" variant="primary" onClick={handleSave}>{I18n.get('confirm')}</Button>
          </Modal.Footer>
        </Modal>
      }
    </div>
  );
}
